import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { EmptyState } from "@shopify/polaris";
import {
  RemoveStudentFromClass,
  addStudentToClass,
  deleteStudentSelfLearning,
  getClassDetail,
  getCourseDetail,
  getListStudentSelfLearning,
  restoreStudentSelfLearning,
} from "../services";
import EvaluationForm from "../components/evaluation.form";
import emptyIMG from "../../../media/empty.png";
import EvaluationList from "./evaluation.list";
import WarningDeleteUser from "../components/warningDeleteUser";
import { getListUser, getListUserWhenAdd } from "entities/users/service";
import { User } from "entities/users/interface";
const style = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "80%",
  borderRadius: 2,
  bgcolor: "white",
  boxShadow: "2px 4px 10px #ededeb",
  marginLeft: "10%",
  p: 2,
};
const ListStudents = () => {
  const params = useParams();
  const { id } = params;
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [currentStudent, setCurrentStudent] = React.useState<number>();
  const [classIndex, setclassIndex] = React.useState<string>("");
  const [active, setActive] = React.useState(false);
  const [messageSnackBar, setMessageSnackBar] = React.useState("");
  const [courseType, setCourseType] = useState("");
  const [listUser, setListUser] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openAddMember, setOpenAddMember] = useState(false);
  const [dataClass, setDataClass] = useState("");
  const [studentId, setStudentId] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef<IntersectionObserver | null>(null);
  const admin_room_id = useRef(null);

  const [dataStudentSelf, setDataStudentSelf] = useState([]);

  const toggleActive = React.useCallback(
    () => setActive((active) => !active),
    []
  );
  const handleOpenModal = (index, classIndex) => {
    setclassIndex(classIndex);
    setCurrentStudent(index);
    setOpen(true);
  };
  const handleShowAddmember = (item, classIndex) => {
    setOpenAddMember(true);
    setDataClass(item._id);
    // console.log("addMember", item, ",,,", classIndex, "...", users);
  };
  const handleCloseModal = () => setOpen(false);
  const handleCloseModalMember = () => setOpenAddMember(false);
  const fetchUsers = async (page: number, search = "") => {
    try {
      const response = await getListUserWhenAdd(page, 10, search);
      const newUsers = response.data || [];
      setListUser((prev) => (page === 1 ? newUsers : [...prev, ...newUsers]));
      setHasMore(newUsers.length > 0);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  React.useEffect(() => {
    fetchUsers(page, searchTerm);
  }, [page, searchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setPage(1); 
  };

  const lastUserRef = useCallback(
    (node: HTMLElement | null) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore]
  );

  React.useEffect(() => {
    fetchUsers(1, ""); 
    getData();
    getDataSelf();
    _getCourseDetail();
  }, []);
  
  const _getCourseDetail = async () => {
    const res = await getCourseDetail(id);
    admin_room_id.current = res?.data?.user_id?._id;
  };
  const _getListUser = () => {
    getListUserWhenAdd().then((response) => {
      setListUser(response.data);
    });
  };

  const filteredUsers = listUser.filter((user) =>
    user.display_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getDataSelf = () => {
    getListStudentSelfLearning(id).then((res) => {
      if (res?.data) {
        setDataStudentSelf(res.data);
      }
    });
  };
  const getData = () => {
    setLoading(true);
    getClassDetail(id).then((res) => {
      setLoading(false);
      if (res?.data) {
        setData(res.data);
        setCourseType("class");
      } else {
        throw new Error(res.message);
      }
    });
  };

  const addUserCourseSelf = (idStudent: string, course_id) => {
    const data = {
      course_id: course_id,
      user_id: idStudent,
    };
    restoreStudentSelfLearning(data).then((res) => {
      if (res.status == 200) {
        setMessageSnackBar("Thêm học sinh vào lớp thành công");
        getDataSelf();
        handleCloseModalMember();
      }
    });
  };
  const addUserCourseClass = (idStudent: string, course_id) => {
    const data = {
      class_id: course_id,
      user_id: idStudent,
      admin_room_id: admin_room_id.current,
    };
    if (!admin_room_id.current) {
      setMessageSnackBar("Không tìm thấy giáo viên!");
      _getCourseDetail();
      return;
    }
    addStudentToClass(data).then((res) => {
      if (res.status == 200) {
        setMessageSnackBar("Thêm học sinh vào lớp thành công");
        getData();
        handleCloseModalMember();
      }
    });
  };

  const _removeUserCourseClass = (idStudent: string, class_id) => {
    // console.log("idStudent...", idStudent);
    // console.log("class_id...", class_id);
    const data = {
      class_id: class_id,
      user_id: idStudent,
    };
    RemoveStudentFromClass(data).then((res) => {
      if (res.status == 200) {
        setMessageSnackBar("Xoá học sinh thành công");
        getData();
        setStudentId("");
      }
    });
  };

  const handleAddMember = (type, classID, userId) => {
    if (type === "class") {
      // thêm vào khoá học class
      addUserCourseClass(userId, classID);
    } else {
      addUserCourseSelf(userId, classID);
    }
  };

  const renderItem = (item, classIndex) => {
    return (
      <Stack gap={1}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="h6">{item.name}</Typography>
          <Stack>
            <EvaluationList classId={item._id} />
          </Stack>
        </Stack>
        <Button onClick={() => handleShowAddmember(item, classIndex)}>
          <Typography sx={{ color: "green" }}>+ Thêm học sinh</Typography>
        </Button>
        {item.members.length > 0 ? (
          <Stack gap={1} bgcolor={"white"} padding={1}>
            {item.members.map((member, index) => (
              <Box key={index}>
                {/* {renderStudentList(member, index, classIndex, item._id)}
                 */}
                <StudentList
                  openModalCallback={() => handleOpenModal(index, classIndex)}
                  setStudentId={setStudentId}
                  studentId={studentId}
                  item={member}
                  index={index}
                  classIndex={classIndex}
                  idClass={item._id}
                  _removeUserCourseClass={_removeUserCourseClass}
                />
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography>There are no students in this class</Typography>
        )}
      </Stack>
    );
  };
  //   const handleClose = (
  //     event: React.SyntheticEvent | Event,
  //     reason?: SnackbarCloseReason
  //   ) => {
  //     if (reason === "clickaway") {
  //       return;
  //     }

  //     setOpen(false);
  //   };
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!loading && dataStudentSelf.length == 0 && data.length == 0) {
    return <EmptyState heading="Classes are empty!" image={emptyIMG} />;
  }

  return (
    <Box
      // sx={{
      //   display: "flex",
      //   flexDirection: "column",
      //   px: 2,
      //   gap: 2,
      //   // width: "100%",
      //   // maxWidth: "80%",
      //   borderRadius: 2,
      //   bgcolor: "white",
      //   boxShadow: "2px 4px 10px #ededeb",
      //   // marginLeft: "10%",
      //   marginTop: 2,
      //   p: 2,
      // }}
      sx={style}
    >
      <Typography variant="h5">{"Danh sách học sinh"}</Typography>
      {data.map((item, index) => (
        <Stack gap={2} key={index}>
          {renderItem(item, index)}
        </Stack>
      ))}
      {data.length == 0 &&
        dataStudentSelf.map((item) => (
          <ItemStudentSelfLearning id={id} item={item} key={item._id} />
        ))}

      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <EvaluationForm
            //   messageSnackBar={messageSnackBar}
            setMessageSnackBar={setMessageSnackBar}
            handleCloseModal={handleCloseModal}
            classId={data[classIndex]?._id}
            studentId={data[classIndex]?.members[currentStudent]?._id}
            toggleActive={toggleActive}
          />
        </Box>
      </Modal>
      <Modal
        open={openAddMember}
        onClose={handleCloseModalMember}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            boxShadow: 24,
            maxHeight: "70%",
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            overflowY: "auto",
          }}
        >
          <Typography variant="h5">{`Thêm học sinh`}</Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Tìm kiếm theo tên..."
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ mb: 2 }}
          />
          {listUser.map((user, index) => {
            const isLastItem = listUser.length === index + 1;
            return (
              <Button
                key={user._id}
                ref={isLastItem ? lastUserRef : null}
                onClick={() =>
                  handleAddMember(courseType, dataClass, user._id, undefined)
                }
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <Stack direction="row" gap={2} alignItems="center">
                  <img
                    src={user?.user_avatar || user?.user_avatar_thumbnail}
                    style={{ height: 50, width: 50, borderRadius: "50%" }}
                  />
                  <Stack
                    direction="column"
                    spacing={0.5}
                    alignItems="flex-start"
                  >
                    <Typography
                      variant="body1"
                      textTransform="none"
                      display="block"
                    >
                      {user.display_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      textTransform="none"
                      color="text.secondary"
                      display="block"
                    >
                      {user.user_email}
                    </Typography>
                  </Stack>
                </Stack>
              </Button>
            );
          })}
          {!hasMore && <Typography>Không còn dữ liệu</Typography>}
        </Box>
      </Modal>
      <Snackbar
        open={active}
        autoHideDuration={6000}
        onClose={toggleActive}
        message={messageSnackBar}
        color="#58fc66"
        // action={action}
      />
    </Box>
  );
};

const ItemStudentSelfLearning = ({ item, id }) => {
  const [isDelete, setIsDelete] = useState(false);
  const [studentId, setStudentId] = useState("");

  const deleteUserCourse = (idStudent: string) => {
    const data = {
      course_id: id,
      user_id: idStudent,
    };
    setStudentId("");
    deleteStudentSelfLearning(data).then((res) => {
      setIsDelete(true);
    });
  };

  const restoreUserCourse = (idStudent: string) => {
    const data = {
      course_id: id,
      user_id: idStudent,
    };
    restoreStudentSelfLearning(data).then((res) => {
      setIsDelete(false);
    });
  };
  return (
    <>
      <Box
        key={item._id}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderWidth: "0px 0px 1px 0px",
          borderStyle: "solid",
          borderColor: "#e0dede",
          p: 1,
        }}
      >
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <img
            src={item.user_avatar || item.user_avatar_thumbnail}
            style={{ height: 50, width: 50, borderRadius: 100 }}
          />
          <Typography variant="body1">{item.display_name}</Typography>
        </Stack>
        {isDelete ? (
          <Button onClick={() => restoreUserCourse(item._id)}>
            <Typography sx={{ color: "green" }}>Khôi phục</Typography>
          </Button>
        ) : (
          <Button onClick={() => setStudentId(item._id)}>
            <Typography sx={{ color: "red" }}>Xoá</Typography>
          </Button>
        )}
      </Box>
      <WarningDeleteUser
        deleteUser={() => deleteUserCourse(studentId)}
        openDeleteConfirm={studentId !== ""}
        handleClose={() => setStudentId("")}
        title={"Bạn có chắc muốn xoá học sinh này khỏi lớp?"}
        message={"Bạn không thể hoàn tác lại sau khi đã xoá học sinh khỏi lớp."}
      />
    </>
  );
};

const StudentList = ({
  item,
  idClass,
  studentId,
  setStudentId,
  _removeUserCourseClass,
  openModalCallback,
}) => {
  const [showModal, setshowModal] = useState(false);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderWidth: "0px 0px 1px 0px",
          borderStyle: "solid",
          borderColor: "#e0dede",
          p: 1,
        }}
      >
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <img
            src={item.user_avatar || item.user_avatar_thumbnail}
            style={{ height: 50, width: 50, borderRadius: 100 }}
          />
          <Typography variant="body1">{item.display_name}</Typography>
        </Stack>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button
            onClick={() => {
              setStudentId(item._id);
              setshowModal(true);
            }}
          >
            <Typography sx={{ color: "red" }}>Xoá</Typography>
          </Button>
          <Button onClick={openModalCallback}>
            <Typography sx={{ color: "green" }}>Đánh giá</Typography>
          </Button>
        </Box>
      </Box>
      <WarningDeleteUser
        deleteUser={() => _removeUserCourseClass(studentId, idClass)}
        openDeleteConfirm={showModal}
        handleClose={() => {
          setStudentId("");
          setshowModal(false);
        }}
        title={"Bạn có chắc muốn xoá học sinh này khỏi lớp?"}
        message={"Bạn không thể hoàn tác lại sau khi đã xoá học sinh khỏi lớp."}
      />
    </>
  );
};

export default React.memo(ListStudents);
